export default __webpack_public_path__ + "static/winter-ed222be509da8633c2afedcfd8e3f117.jpg";